import { HSLColor } from '@yola/yola-palette-generator';
import color from './color';

const highEmphasis = ({ backgroundColor, whiteColor, blackColor, surfaceColor }) => {
  const { hue, saturation, lightness } = color({
    backgroundColor,
    whiteColor,
    blackColor,
    surfaceColor,
  });

  return new HSLColor(hue, saturation, lightness, 1);
};

export default highEmphasis;
